module.exports = __webpack_public_path__ + "media/images/product-bg-9dd670d0c707d36d3450a070496d4701.jpg";